import { getSiteAudio, getSiteDocument, getSiteImage, getSiteVideo } from './siteAssets';

const siteTapTapUrl = import.meta.env.VITE_SITE_TAPTAP_URL || 'https://l.taptap.cn/m5KMxZau?channel=rep-rep_xvonfbcgstt';
const siteForumUrl = import.meta.env.VITE_SITE_TAPTAP_FORUM_URL || 'https://www.taptap.cn/app/817986/topic';
const siteOfficialDevLogUrl = 'https://www.taptap.cn/app/817986/topic?type=official';
const siteIosUrl = import.meta.env.VITE_SITE_IOS_URL || '';
const siteSteamUrl = import.meta.env.VITE_SITE_STEAM_URL || 'https://store.steampowered.com/app/4663300/';
const siteFeedbackUrl = 'https://l.taptap.cn/VXJ6gc76?channel=rep-rep_test0i8hxmp64uk_h5url7551';

export const siteLinks = {
  modEditor: import.meta.env.DEV ? 'http://127.0.0.1:4173/' : '/mod-editor/',
  tapTap: siteTapTapUrl,
  forum: siteForumUrl,
  officialDevLogs: siteOfficialDevLogUrl,
  ios: siteIosUrl,
  steam: siteSteamUrl,
  activation: '/activation',
  feedback: siteFeedbackUrl,
  privacy: '/privacy-policy',
  agreement: '/user-agreement',
};

export type SoundtrackEntry = {
  id: string;
  title: string;
  note: string;
  file: string;
  cover: string;
};

export const soundtrackEntries: SoundtrackEntry[] = [
  { id: 'bgm_p2_combat', title: 'P2 Combat', note: '废墟推进 / 高压交战', file: getSiteAudio('bgm_p2_combat'), cover: getSiteImage('promo_40') },
  { id: 'bgm_p2_combat2', title: 'P2 Combat II', note: '钢铁车队 / 深夜行军', file: getSiteAudio('bgm_p2_combat2'), cover: getSiteImage('hero_main') },
  { id: 'crazy', title: 'Crazy', note: '车内 live / 情绪升温', file: getSiteAudio('crazy'), cover: getSiteImage('guitar_live') },
  { id: 'downcounter', title: 'DownCounter', note: '倒计时 / 末日上车', file: getSiteAudio('downcounter'), cover: getSiteImage('board_now') },
  { id: 'mryyzn', title: 'MRYYZN', note: '生存间隙 / 深夜电台', file: getSiteAudio('mryyzn'), cover: getSiteImage('poster_0') },
];

export const heroContent = {
  eyebrow: 'REBIRTH HOARDER · OFFICIAL SITE',
  title: '末世：我有一辆房车',
  subtitle: '在停电、风雪与废墟之间，把一辆房车经营成最后的移动基地。',
  description:
    '重生、囤货、移动堡垒与微信叙事共同组成这个雪夜末世。你可以在这里下载游戏、观看宣传片、查攻略、追更新，也能直接进入 PC Web MOD 编辑器写下自己的废土故事。',
  highlight: 'TapTap 安卓现已开放，PC Web MOD 编辑器同步上线。',
  background: getSiteImage('hero_main'),
  badges: ['TapTap 安卓', 'PC MOD 编辑器', '论坛攻略', '官方宣传片', '持续更新'],
};

export const trailerContent = {
  title: '官方宣传片',
  description:
    '废墟风雪、移动堡垒、车内生活和剧情张力，都被压进了这支正式宣传片里。第一次来到这里的玩家，可以先用几分钟感受这场雪夜末世的气质。',
  video: getSiteVideo('official_trailer'),
  poster: getSiteImage('hero_main'),
  asideImage: getSiteImage('promo_40'),
  asideTitle: '在冰封的炼狱中，打造你的钢铁乌托邦',
  asideDescription: '从车体、岗位、路线，到废墟探索和长期成长，你会在同一辆车里撑起整座末世据点。',
};

export const boardingContent = {
  image: getSiteImage('board_now'),
  title: '立即上车',
  subtitle: '末日倒计时只剩 10 分钟，你的车票准备好了吗？',
  description:
    '车门已经打开，补给、同伴和最后的希望都在等你装车出发。现在就前往安卓下载，或者先去体验 PC Web MOD 编辑器。',
};

export const platformEntries = [
  {
    id: 'android',
    title: 'TapTap Android',
    status: 'available' as const,
    kicker: '现已可玩',
    description: '安卓正式体验入口，提供完整生存经营、剧情手机系统、TapTap 云存档与社区反馈能力。',
    href: siteLinks.tapTap,
    cta: '前往下载',
    note: '推荐入口',
  },
  {
    id: 'ios',
    title: 'iOS',
    status: 'coming' as const,
    kicker: '预约中',
    description: 'iOS 版本正在准备中，开放后会第一时间在官网与社区公布最新消息。',
    href: siteLinks.ios,
    cta: '即将上线',
    note: '敬请期待',
  },
  {
    id: 'steam',
    title: 'Steam',
    status: 'available' as const,
    kicker: '商店页已上线',
    description: 'Steam 商店页现已开放。官网手游免广领取通道已下线。',
    href: siteLinks.steam,
    cta: '打开商店页',
    note: '愿望单开放',
  },
];

export const featureCards = [
  {
    title: '末世前炒股搞钱囤货',
    description: '从公司早报、股价波动到仓库清单，先在灾变降临前完成资金滚动与物资囤积，把生存优势直接带进末世开局。',
    image: getSiteImage('promo_core_stock'),
  },
  {
    title: '肉鸽玩法重生日记',
    description: '永久肉鸽“重生日记”把一次次轮回、事件选择和成长收益织进主循环，让每次重开都像重新校准命运路线。',
    image: getSiteImage('promo_core_roguelike'),
  },
  {
    title: '房车进化改装',
    description: '围绕移动基地持续扩建车体、岗位、设备与生存链路，把一辆房车一步步进化成真正能扛住末世的钢铁堡垒。',
    image: getSiteImage('promo_core_rv_upgrade'),
  },
  {
    title: '卡牌策略战斗',
    description: '通过手牌构筑、队员协同与战斗节奏博弈处理废墟冲突，用更强调判断和资源调度的方式打穿高压遭遇战。',
    image: getSiteImage('promo_core_card_battle'),
  },
  {
    title: '移动堡垒经营',
    description: '围绕一辆房车建立完整生存中枢，从岗位、资源、改装到长期发展，形成独特的“堡垒经营”主轴。',
    image: getSiteImage('promo_40'),
  },
  {
    title: '微信式末日叙事',
    description: '联系人、聊天树、朋友圈与新闻播报共同推进剧情，情感线和日常感让末世叙事更贴近现实。',
    image: getSiteImage('微信联系人'),
  },
  {
    title: '废墟回响',
    description: '从废墟探索到小队派遣，再到更高阶段的地图和成长线，P2 之后的内容密度持续抬升。',
    image: getSiteImage('promo_30'),
  },
  {
    title: 'PC Web MOD 创作',
    description: '官网直接开放 PC Web MOD 编辑器入口，让玩家和作者在大屏工作台里编排自己的末世故事。',
    image: getSiteImage('mod_editor_entry'),
  },
];

export type ModEditorShowcaseEntry = {
  id: string;
  eyebrow: string;
  title: string;
  description: string;
  image: string;
  chips: string[];
  highlights: string[];
};

export const modEditorShowcaseLead =
  '极具乐趣的创意工坊设计，还原游戏沉浸式创作体验，简单易上手，如同游戏一般定义你的末世世界。';

export const modEditorShowcaseFootnote = '手机游戏端已同步上线内置版创意工坊，也可体验。';

export const modEditorShowcaseEntries: ModEditorShowcaseEntry[] = [
  {
    id: 'hub',
    eyebrow: 'PROJECT HUB',
    title: '从废土指挥台进入整套 MOD 工程',
    description: '创建工程、继续创作、导入项目与社区分享都在同一首页完成，先把创作入口做得像一款真正的游戏工作台。',
    image: getSiteImage('mod_editor_entry'),
    chips: ['工程中心', '社区分享', '最近记录'],
    highlights: ['一键进入新建 / 导入 / 继续创作', '保存状态与最近编辑时间可见', '从入口页就能感受到废土指挥台的气质'],
  },
  {
    id: 'chat',
    eyebrow: 'CHAT FLOW',
    title: '把微信剧情树做成真正可视化的叙事工作流',
    description: '聊天流图、节点属性与手机预览同屏协作，复杂分支也能快速看清楚、改明白。',
    image: getSiteImage('mod_editor_chat_flow'),
    chips: ['微信聊天', '节点流图', '手机预览'],
    highlights: ['支持消息、选项、跳转与结束节点', '右侧属性面板实时同步内容', '复杂剧情不再困在小屏列表里'],
  },
  {
    id: 'npc',
    eyebrow: 'NPC PROFILE',
    title: '角色档案、招募模板和引用关系一次看全',
    description: 'NPC 模块不是纯表单，而是人物档案预览、关系摘要和字段检查器协同工作的角色工作台。',
    image: getSiteImage('mod_editor_npc'),
    chips: ['NPC 档案', '关系摘要', '官方模板'],
    highlights: ['姓名、头像、简介和标签即时预览', '招募、礼物、联系人资料同页编辑', '可直接复制官方案例继续改造'],
  },
  {
    id: 'event',
    eyebrow: 'EVENT STAGE',
    title: '剧情弹窗像真正的剧情舞台一样预览',
    description: '标题、正文、分支选项、条件和奖励都能在同一个事件舞台里检查，编排剧情节奏更顺手。',
    image: getSiteImage('mod_editor_event'),
    chips: ['剧情弹窗', '分支卡', '触发条件'],
    highlights: ['事件预览直接还原游戏里的弹窗观感', '条件、flags、物品奖励集中编辑', '适合做有分支反馈的关键剧情节点'],
  },
  {
    id: 'news',
    eyebrow: 'NEWS DESK',
    title: '新闻播报与评论区也能成为剧情推进器',
    description: '头图、来源、正文、hint、评论作者与时间统一排布，适合把世界观信息做成更有沉浸感的播报。',
    image: getSiteImage('mod_editor_news'),
    chips: ['新闻播报', '正文编辑', '评论区'],
    highlights: ['预览区直接展示新闻成稿效果', '发布时间与阶段条件同步编辑', '很适合做灾变播报和世界观补充'],
  },
  {
    id: 'moments',
    eyebrow: 'SOCIAL FEED',
    title: '朋友圈动态让废土世界更有“活人感”',
    description: '作者、正文、多图、点赞和评论都能像真实动态流一样编排，适合塑造角色日常和剧情余波。',
    image: getSiteImage('mod_editor_moments'),
    chips: ['朋友圈', '多图动态', '评论互动'],
    highlights: ['发帖内容与评论名单统一管理', '支持阶段、天数和 flags 触发', '把角色状态变化更自然地散进剧情里'],
  },
  {
    id: 'items',
    eyebrow: 'ITEM LAB',
    title: '物品模块覆盖剧情物品、消耗品和装备',
    description: '背包卡与属性面板并排呈现，做剧情掉落、数值道具和简化装备都会更直观。',
    image: getSiteImage('mod_editor_items'),
    chips: ['物品配置', '引用统计', '装备属性'],
    highlights: ['物品类型切换后字段自动聚焦', '能看到条目被哪些剧情和聊天引用', '适合快速搭一套完整奖励链路'],
  },
  {
    id: 'assets',
    eyebrow: 'ASSET LIBRARY',
    title: '内置素材库直接联通图片、场景与角色资源',
    description: '从聊天图片到角色形象，再到新闻和朋友圈素材，都可以在同一个素材库里检索和插入。',
    image: getSiteImage('mod_editor_asset_library_game'),
    chips: ['内置素材库', '游戏同源', '一键插入'],
    highlights: ['统一管理场景图、角色图和聊天媒体', '素材筛选与当前字段联动', '减少反复切换面板的成本'],
  },
  {
    id: 'audio',
    eyebrow: 'AUDIO LIBRARY',
    title: '连音效与音乐素材也能在工作台里统一调用',
    description: '音频素材集中展示，做语音节点、氛围配乐和特殊反馈时不会再四处找资源。',
    image: getSiteImage('mod_editor_asset_library_audio'),
    chips: ['音效音乐', '语音节点', '氛围调用'],
    highlights: ['素材名、分类与目标字段保持对应', '适合聊天语音和剧情氛围补足', '让 MOD 创作更接近完整内容制作'],
  },
];

export const galleryEntries = [
  {
    title: '雪夜移动堡垒',
    description: '房车不是背景设定，而是整个世界观与玩法循环的中心。',
    image: getSiteImage('hero_main'),
    variant: 'wide' as const,
  },
  {
    title: '立即上车',
    description: '末日列车已经鸣笛，下一站是风雪中的移动堡垒。',
    image: getSiteImage('board_now'),
    variant: 'wide' as const,
  },
  {
    title: '车内弹唱时刻',
    description: '生活气息、角色魅力和末世孤独感，都可以在车内的细节里被看见。',
    image: getSiteImage('guitar_live'),
    variant: 'tall' as const,
  },
  {
    title: '冰封炼狱中的钢铁乌托邦',
    description: '风雪、钢铁和灯火同框，正是这辆房车在末世里最迷人的样子。',
    image: getSiteImage('promo_40'),
    variant: 'wide' as const,
  },
  {
    title: 'TapTap 独家首发海报',
    description: '从第一眼开始，就能记住这辆在末世风雪里前行的房车。',
    image: getSiteImage('poster_0'),
    variant: 'standard' as const,
  },
  {
    title: '小队派遣与废墟推进',
    description: '中后期的探索、战斗与派遣构成了末世成长线的深水区。',
    image: getSiteImage('小队派遣'),
    variant: 'standard' as const,
  },
];

export const guideEntries = [
  { title: 'TapTap 论坛攻略主阵地', description: '新手问题、版本讨论、流派心得与官方交流都在 TapTap 论坛持续更新。', href: siteLinks.forum, cta: '进入论坛', badge: '官方推荐', highlight: true },
  { title: '卡牌战斗新手教学', description: '适合刚接触废墟卡牌战斗的玩家快速建立基础理解。', href: getSiteDocument('卡牌战斗新手教学'), cta: '查看 PDF', badge: '精选资料' },
  { title: '精英挑战与守关 BOSS', description: '汇总高难挑战和守关战的关键打法与机制要点，适合中后期玩家查阅。', href: getSiteDocument('精英挑战&守关boss'), cta: '查看 PDF', badge: '进阶向' },
];

export const updateEntries = [
  { version: 'v3.8.5', title: '版本调优与系统打磨', summary: '围绕现有主线系统继续做稳定性、节奏和体验层优化，提升整体游玩完成度。', image: getSiteImage('3.8.5更新内容') || getSiteImage('3.8更新内容1'), spotlight: getSiteImage('日结面板') },
  { version: 'v3.8', title: '命途、战斗与成长线扩展', summary: '补入命途方向、战斗演出与中后期养成亮点，让末世经营和战斗成长更立体。', image: getSiteImage('3.8更新内容1'), spotlight: getSiteImage('命途-万藏') },
  { version: 'v3.6', title: '废土经营深度继续上探', summary: '生产链、养殖、农场和厨房相关内容被进一步强化，房车工作台更像真正的移动基地。', image: getSiteImage('3.6 更新内容'), spotlight: getSiteImage('末世厨房') },
  { version: 'v3.5', title: 'P3 剧情与新阶段内容预告', summary: '更高阶段的剧情演进、Boss 出场和世界观推进让内容进入新的扩展周期。', image: getSiteImage('3.5更新内容'), spotlight: getSiteImage('boss入场') },
  { version: 'v3.0', title: '废墟回响：地图与队员强化', summary: '用官方 3.0 宣传图直接回顾这一阶段的主打变化：地图搜打撤、队员养成强化，以及中后期废墟体验的成型。', image: getSiteImage('promo_30'), spotlight: getSiteImage('废墟探索1') },
];

export type OfficialDevLogEntry = {
  index: number;
  date: string;
  title: string;
  summary: string;
  href: string;
};

export const officialDevLogEntries: OfficialDevLogEntry[] = [
  {
    index: 1,
    date: '2026-02-24',
    title: '【开发日志 01】上线首日：感谢包容，连夜修 Bug 的头发没白掉！',
    summary: '首篇日志记录上线后的第一轮反馈与修复节奏，适合回看项目最早期的状态和玩家初印象。',
    href: 'https://www.taptap.cn/moment/775286165224818988',
  },
  {
    index: 2,
    date: '2026-02-24',
    title: '【开发日志 02】上线第二天：把 “Bug” 修成 “游戏” 的路上！',
    summary: '继续接着首发后的修补和打磨，能看到早期版本是如何快速收束体验问题的。',
    href: 'https://www.taptap.cn/moment/775498216022999810',
  },
  {
    index: 3,
    date: '2026-02-26',
    title: '【开发日志 03】剧情升级！仓库囤货爽感拉满，生存100天挑战',
    summary: '聚焦剧情推进、仓库囤货与长期生存目标，能更直观看到末世经营线的雏形。',
    href: 'https://www.taptap.cn/moment/776197409653918261',
  },
  {
    index: 4,
    date: '2026-02-28',
    title: '【开发日志 4】更新公告',
    summary: '一篇早期更新公告，适合回顾版本修正和当时主线体验的收束方向。',
    href: 'https://www.taptap.cn/moment/776879362841511953',
  },
  {
    index: 5,
    date: '2026-03-01',
    title: '开发日志 5｜云存档 + 排行榜上线！榜上见真章',
    summary: '云存档和排行榜一并上线，把长期游玩和竞争展示都补上了关键的一环。',
    href: 'https://www.taptap.cn/moment/777246041991809994',
  },
  {
    index: 6,
    date: '2026-03-03',
    title: '【开发日志6】进度汇报',
    summary: '一次阶段性进度汇报，用来了解当时开发推进到了哪些重点模块。',
    href: 'https://www.taptap.cn/moment/778006311773145476',
  },
  {
    index: 7,
    date: '2026-03-06',
    title: '【开发日志7】重大更新预告！队员养成+新版战斗装备系统',
    summary: '预告队员养成与新版战斗装备系统，是中后期成长线逐步成型的重要节点。',
    href: 'https://www.taptap.cn/moment/779110356122338581',
  },
  {
    index: 8,
    date: '2026-03-09',
    title: '【开发日志8】2.1版本更新，永久肉鸽【重生日记】上线！',
    summary: '2.1 版本把永久肉鸽“重生日记”带进游戏循环，是玩法扩展感很强的一次更新。',
    href: 'https://www.taptap.cn/moment/780214722598273706',
  },
  {
    index: 9,
    date: '2026-03-12',
    title: '【开发日志9】更新预告 - 集中消灭一波bug',
    summary: '围绕稳定性和体验细节做了一轮集中修整，适合回顾版本打磨期的重点问题。',
    href: 'https://www.taptap.cn/moment/781302621699837234',
  },
  {
    index: 10,
    date: '2026-03-16',
    title: '【开发日志10】2.2优化版本已更新！',
    summary: '2.2 优化版继续往节奏、反馈和整体手感上深挖，是过渡到更大版本前的重要铺垫。',
    href: 'https://www.taptap.cn/moment/782714550330853926',
  },
  {
    index: 11,
    date: '2026-03-21',
    title: '【开发日志11】重大更新：全新3.0版本 - 废墟回响上线',
    summary: '3.0“废墟回响”正式上线，标志着内容量和阶段推进都迈进了新的周期。',
    href: 'https://www.taptap.cn/moment/784415734552856226',
  },
  {
    index: 12,
    date: '2026-03-25',
    title: '【开发日志12】3.1版本迭代更新：背包一键整理上线！',
    summary: '3.1 版本把高频操作体验继续补强，背包一键整理是玩家感知很直接的一项优化。',
    href: 'https://www.taptap.cn/moment/785981470098327982',
  },
  {
    index: 13,
    date: '2026-03-29',
    title: '【开发日志13】更新公告 - 3.2 优化版本',
    summary: '3.2 版本延续细修节奏，让已有系统更顺手、更稳定。',
    href: 'https://www.taptap.cn/moment/787431793644015305',
  },
  {
    index: 14,
    date: '2026-04-03',
    title: '【开发日志 14】3.5 版本重磅更新！剧情更新・精英 BOSS 上线',
    summary: '剧情推进与精英 BOSS 一起上线，3.5 是内容层存在感很强的一次跨步。',
    href: 'https://www.taptap.cn/moment/789220695425945018',
  },
  {
    index: 15,
    date: '2026-04-09',
    title: '【开发日志 15】3.6 优化版本！房车武器工坊上线・新手引导强化',
    summary: '房车武器工坊加入版本主线，同时把新手引导做得更完整，兼顾新内容和上手体验。',
    href: 'https://www.taptap.cn/moment/791392693249902747',
  },
  {
    index: 16,
    date: '2026-04-14',
    title: '【开发日志 16】3.8更新公告：生态田园 | 厨神之路 | 双线命途',
    summary: '生态田园、厨神之路和双线命途共同构成 3.8 的版本核心，看点很集中。',
    href: 'https://www.taptap.cn/moment/793215892832912753',
  },
  {
    index: 17,
    date: '2026-04-17',
    title: '【开发日志 17】3.8.5更新公告：痛点问题修复，优化版本',
    summary: '围绕玩家痛点继续做修复与体验打磨，是 3.8 系列的优化收束版本。',
    href: 'https://www.taptap.cn/moment/794167975157436016',
  },
];

export const communityEntries = [
  { title: '核心玩家 1 群', description: '版本前瞻 / 补偿码 / 抢先反馈 / 活跃讨论', value: 'QQ 1038765117', href: 'https://qm.qq.com/q/bHJNwfnZ72' },
  { title: '核心玩家 2 群', description: '1 群满员或活动分流时加入', value: 'QQ 1076405438' },
  { title: 'Bug 反馈', description: '优先通过 TapTap 官方反馈入口提交问题和建议。', value: 'TapTap 反馈通道', href: siteLinks.feedback },
];

export const legalEntries = [
  { title: '隐私政策', description: '查看游戏与创意工坊相关的隐私说明。', href: siteLinks.privacy },
  { title: '用户协议', description: '查看服务使用、内容创作与导出相关的协议内容。', href: siteLinks.agreement },
];
